import React from 'react';
import { Autocomplete, Box, CircularProgress, TextField } from '@mui/material';
import { useGetMetersHandler } from '../dataHandlers/getMetersHandler';
import { Controller } from 'react-hook-form';
import useMeterFilters from './MeterFilterHelper';
import { find } from 'lodash';

const MeterSelect = ({ label, name, control, errors, readOnly = false, disabled = false }) => {
  const { currentQuery, handleSearchChange } = useMeterFilters({ defaultQuery: {}, searchOnChange: true });
  const { meters, isLoading } = useGetMetersHandler({ searchQuery: currentQuery });

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Box display="flex" alignItems="flex-start" gap={2}>
          <Autocomplete
            {...field}
            id={name}
            fullWidth
            loading={isLoading}
            readOnly={readOnly}
            disabled={disabled}
            options={meters}
            getOptionLabel={(value) => {
              if (typeof value === 'string') {
                return find(meters, { meter_id: value })?.display_name || '-';
              }
              return value?.display_name || '-';
            }}
            getOptionKey={(option) => {
              return option?.meter_id;
            }}
            renderInput={(params) => (
              <TextField
                {...params}
                label={label}
                error={!!errors[name]}
                helperText={errors[name]?.message || ''}
                slotProps={{
                  input: {
                    ...params.InputProps,
                    endAdornment: (
                      <React.Fragment>
                        {isLoading ? <CircularProgress color="inherit" size={20} /> : null}
                        {params.InputProps.endAdornment}
                      </React.Fragment>
                    ),
                  },
                }}
              />
            )}
            isOptionEqualToValue={(option, value) => {
              return option.meter_id === value;
            }}
            onChange={(_, value) => {
              const finalValue = value === null ? null : typeof value === 'string' ? value : value.meter_id;
              field.onChange(finalValue);
            }}
            value={field?.value || null}
            onInputChange={(event, value, reason) => {
              if (reason === 'input') {
                handleSearchChange(event);
              }
            }}
            filterOptions={(x) => x}
          />
        </Box>
      )}
    />
  );
};

export default MeterSelect;
